export const useSearchStore = defineStore('search', () => {
  const { $api } = useNuxtApp()
  const minChars = ref<number>(3)
  const pages = ref<SearchResult>({ type: '', title: '', results: [] })
  const categories = ref<SearchResult>({ type: '', title: '', results: [] })
  const searchTerm = ref<string | null>()
  const products = ref<SearchResult>({ type: '', title: '', results: [] })
  const pagination = ref<Pagination>({ totalProducts: null, cursor: null, allLoaded: false })
  const loading = ref<boolean>(false)
  const errorMessage = ref<string>()
  const finished = ref(false)

  const load = async (query: string | null, { append = false, limits = null } = {}) => {
    searchTerm.value = query

    if (!searchTerm.value) { return }

    if (searchTerm.value && searchTerm.value.length < minChars.value) {
      errorMessage.value = 'notEnoughChars'
      return
    }
    loading.value = true

    try {
      const data: SearchResults = await $api('search', {
        params: { params: searchTerm.value, cursor: pagination.value?.cursor, limits: limits ? true : undefined }
      })

      if (data) {
        pages.value.title = data.pages.title
        pages.value.results = append ? [...pages.value.results, ...data.pages.results] : data.pages.results
        categories.value.title = data.categories.title
        categories.value.results = append ? [...categories.value.results, ...data.categories.results] : data.categories.results
        products.value.title = data.products.title
        products.value.results = append ? [...products.value.results, ...data.products.results] : data.products.results
        pagination.value = {
          totalProducts: data.pagination.value?.totalProducts,
          cursor: data.pagination.cursor,
          allLoaded: data.pagination.allLoaded
        }

        errorMessage.value = ''
        finished.value = data.pagination.allLoaded
      }
    } catch (e) {
      errorMessage.value = 'noResults'
    }

    loading.value = false
  }

  const loadMore = async () => {
    if (pagination.value?.allLoaded || !searchTerm.value || loading.value) { return }
    await load(searchTerm.value, { append: true })
  }

  const reset = () => {
    pages.value = { type: '', title: '', results: [] }
    categories.value = { type: '', title: '', results: [] }
    products.value = { type: '', title: '', results: [] }
    pagination.value = { totalProducts: null, cursor: null, allLoaded: false }
    errorMessage.value = ''
    searchTerm.value = null
    loading.value = false
    finished.value = false
  }

  const totalLoadedProducts = computed(() => products.value.results.length)
  return { finished, minChars, searchTerm, pages, categories, products, pagination, loading, errorMessage, load, loadMore, reset, totalLoadedProducts }
})
